import { Badge } from '@repo/ui/components/ui/badge'
import { Button } from '@repo/ui/components/ui/button'
import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowUpRight, CalendarPlus } from 'lucide-react'
import { WorkspaceRouteShell } from '@/components/app/route-shells'
import { AppTopBarActionGroup, AppTopBarActions } from '@/components/app/top-bar-actions'
import { OperatorOverview } from '@/components/features/dashboard/operator-overview'
import { useNotifications } from '@/lib/notifications'
import { useOperatorConfiguration } from '@/lib/operator-config/use-operator-configuration'
import type { RouteStaticData } from '@/lib/router/breadcrumbs'

export const Route = createFileRoute('/_app/')({
  component: AppPage,
  staticData: {
    breadcrumbs: [{ label: 'Today' }],
  } satisfies RouteStaticData,
})

function AppPage() {
  const { unreadCount } = useNotifications()
  const { configuration } = useOperatorConfiguration()

  return (
    <WorkspaceRouteShell>
      <AppTopBarActions>
        <AppTopBarActionGroup>
          {unreadCount > 0 ? <Badge variant="destructive">{unreadCount} unread</Badge> : null}
          <Button asChild size="sm" className="gap-2">
            <Link to={configuration.operator ? '/appointments' : '/setup'}>
              <CalendarPlus className="h-4 w-4" />
              {configuration.operator ? 'Add booking' : 'Finish setup'}
            </Link>
          </Button>
          {configuration.operator?.slug ? (
            <Button asChild variant="outline" size="sm" className="gap-2">
              <a href={`/book/${configuration.operator.slug}`} target="_blank" rel="noreferrer">
                Open booking page
                <ArrowUpRight className="h-4 w-4" />
              </a>
            </Button>
          ) : null}
        </AppTopBarActionGroup>
      </AppTopBarActions>
      <OperatorOverview mode="home" />
    </WorkspaceRouteShell>
  )
}
